export const toggleAdilloMessage = value => dispatch => {
  dispatch({ type: 'TOGGLE_ADILLO_MSG', data: value });
};
